import React from "react";
import PropTypes from "prop-types";
import { Grid, makeStyles, Typography, useTheme } from "@material-ui/core";
import translate from "../../../../i18n/translate";
import { SrButton, SrContentHeader, SrContentWrapper } from "../../../common";
import { ImgWithFallback } from "components";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: theme.spacing(67),
    height: theme.spacing(58.5),
    padding: theme.spacing(8.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,

    [theme.breakpoints.down("md")]: {
      height: "100%",
    },

    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(4),
    },
  },
  oxxoImage: {
    marginBottom: theme.spacing(4.25),
    height: theme.spacing(4),
  },
  bbvaImage: {
    marginBottom: theme.spacing(4.25),
    height: theme.spacing(3.5),
  },
  elementMarginBottom: {
    marginBottom: theme.spacing(4.25),
  },
}));

const CashPaymentCard = ({ bank }) => {
  const intl = useIntl();
  const { card, bbvaImage, oxxoImage, elementMarginBottom } = useStyles();

  return (
    <div className={card}>
      <ImgWithFallback
        className={bank === "oxxo" ? oxxoImage : bbvaImage}
        src={`/banks/${bank}.webp`}
        fallback={`/banks/${bank}.png`}
        alt={intl.formatMessage({ id: "cashPayment.createBallot.imageAlt" })}
      />
      <Typography variant="h3" className={elementMarginBottom}>
        {intl.formatMessage({ id: `cashPayment.${bank}Card.title` })}
      </Typography>
      <Typography className={elementMarginBottom}>
        {intl.formatMessage(
          { id: `cashPayment.${bank}Card.content` },
          {
            highlightedContent: (
              <strong>
                {intl.formatMessage({
                  id: `cashPayment.${bank}Card.highlightedContent`,
                })}
              </strong>
            ),
          }
        )}
      </Typography>
    </div>
  );
};

const CashPaymentFirstScreen = ({ onClick }) => {
  const theme = useTheme();

  return (
    <>
      <SrContentHeader title={translate("cashPayment.heading")} />
      <SrContentWrapper isLoading={false}>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
          }}
        >
          <Grid item xs={12} lg={6}>
            <CashPaymentCard bank="oxxo" />
          </Grid>
          <Grid item xs={12} lg={6}>
            <CashPaymentCard bank="bbva" />
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            marginTop: theme.spacing(4.25),
          }}
        >
          <SrButton color="primary" variant="contained" onClick={onClick}>
            {translate("common.apply")}
          </SrButton>
        </Grid>
      </SrContentWrapper>
    </>
  );
};

CashPaymentFirstScreen.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CashPaymentFirstScreen;
